var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatReplyOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13411 16.9455L9.13409 16.9455L1.13409 9.51684L1.13395 9.5167C0.995309 9.38746 0.917578 9.19721 0.917578 8.99994C0.917578 8.80266 0.995311 8.61242 1.13394 8.48315L1.13409 8.483L9.13409 1.05435L9.13419 1.05427C9.31369 0.888007 9.56751 0.851543 9.7802 0.967224L9.78021 0.967234C9.99089 1.08188 10.1176 1.31922 10.1176 1.57125V5.49819C14.0395 5.84935 17.1176 9.60316 17.1176 14.1428V15.2857C17.1176 15.5408 16.9876 15.7803 16.7733 15.893C16.5556 16.0082 16.3003 15.9652 16.1225 15.7913L16.1224 15.7913L15.2796 14.966L15.2796 14.9659C13.8262 13.5423 12.0122 12.6992 10.1176 12.552V16.4286C10.1176 16.6806 9.99089 16.918 9.78021 17.0326L9.77985 17.0328C9.69733 17.0773 9.60784 17.1 9.51756 17.1L9.13411 16.9455ZM9.13411 16.9455C9.24263 17.0462 9.37847 17.1 9.51751 17.1L9.13411 16.9455ZM8.91761 3.00093V6.14272C8.91761 6.50084 9.1739 6.81417 9.51763 6.81417C12.9355 6.81417 15.7547 9.90688 15.9109 13.8021C14.1139 12.1143 11.852 11.1856 9.51759 11.1856C9.17386 11.1856 8.91758 11.499 8.91758 11.8571V14.9989L2.45751 8.99994L2.66679 8.80559L3.42657 8.10004L5.73211 5.95905L8.03767 3.81806L8.79745 3.1125L8.91761 3.00093Z",
    fill: "#778797",
    stroke: "#778797",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatReplyOutline);
export default __webpack_public_path__ + "static/media/chat_reply_outline.44688b1f8f5a4779c0597a9887da5372.svg";
export { ForwardRef as ReactComponent };